/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BranchListPage = lazyLoad(
  () => import('./index'),
  module => module.BranchListPage
);
